'use strict';

module Patersons {
    export interface MorningStarData {
        holdingTypeId: number;
        SecId: string;
        Name: string;
        ExchangeCode: string;
        Symbol: string;
        FundShareClassId: string;
    }
    export class MorningStarService {
        constructor() {
        }
        private mapAgilityExchangeCodeToMIC(exchangeCode){
            switch (exchangeCode) {

                case "HKE":
                case "HKG":
                    exchangeCode = "EX$$$$XHKG"
                    break;
                case "SGX":
                case "SES":
                    exchangeCode = "EX$$$$XSES"
                    break;
                case "NAS":
                    exchangeCode = "EX$$$$XNAS"
                    break;
                case "NYS":
                    exchangeCode = "EX$$$$XNYS"
                    break;
                case "AME":
                case "ASE":
                    exchangeCode = "EX$$$$XASE"
                    break;
                case "LSE":
                case "LON":
                    exchangeCode = "EX$$$$XLON"
                    break;
                case "ETR":
                case "FRA":
                    exchangeCode = "EX$$$$XFRA"
                    break;
                case "PAR":
                    exchangeCode = "EX$$$$XPAR"
                    break;
                case "ARC":
                case "ARCX":
                    exchangeCode = "EX$$$$ARCX"
                    break;
                case "AMS":
                    exchangeCode = "EX$$$$XAMS"
                    break;
                case "MAD":
                case "MCE":
                    exchangeCode = "EX$$$$XMCE"
                    break;
                case "MTA":
                case "MIL":
                    exchangeCode = "EX$$$$XMIL"
                    break;
                case "AXW":
                case "ASX":
                    exchangeCode = "EX$$$$XASX";
                    break;
                default:
                    exchangeCode = "UNL";
                    break;
            }
            return exchangeCode;
        }
        public getRecentResearch = (filterBy1Year?: boolean): Promise<any[]> => {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "https://content.morningstar.com.au/equityxml/customResearchReportXml?client=canaccordgenuity&format=json&v=2&rowsreturn=everything",
                    type: "GET",
                }).then(res => {
                    if (res && res.customArcResearchList) {
                        if(filterBy1Year){
                            var oneYearAgo = new Date();
                            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
                            const filteredItems = res.customArcResearchList.filter((item) => {
                                const date = new Date(item.dateWritten)
                                return date >= oneYearAgo;
                            })
                            resolve(filteredItems);
                        }else{
                            resolve(res.customArcResearchList)
                        }
                    }else{
                        resolve(null)
                    }
                }).fail(res => {
                    resolve(res)
                })
            })
        }
        public getASXAnnouncementsDocument = (path): Promise<any> => {
            const query = {
                path: path
            }
            
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "/financeService/Morningstar/GetASXAnnouncementDocument",
                    data: query,
                    type: "GET",
                }).then(res => {
                    resolve(res)
                }).fail(res => {
                    resolve(res)
                })
            })
        }
        public getASXAnnouncements = (asxcode?, dateRange?, page?): Promise<any> => {
            const query = {} as any;
            if(asxcode){
                query.asxcode = asxcode
            }
            if(dateRange){
                query.dateRange = dateRange
            }
            if(page){
                query.page = page
            }
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "/financeService/Morningstar/GetASXAnnouncements",
                    data: query,
                    type: "GET",
                }).then(res => {
                    resolve(res)
                }).fail(res => {
                    resolve(res)
                })
            })
        }
        public getMorningStarDataForSecurityCode(exchangeCode: string, securityCode: string) : Promise<Patersons.MorningStarData>{
            return new Promise((resolve, reject) => {
                if(!exchangeCode || !securityCode){
                    resolve(null)
                    return;
                }
                // replace : with . for the M* API
                let symbol = securityCode.replace(/:/g, ".");
                // need to append 0 to HKG/KHE security codes
                if (exchangeCode == "HKE" || exchangeCode == "HKG"){
                    symbol = "0" + symbol;
                }       
                $.ajax({
                    url: "https://lt.morningstar.com/api/rest.svc/4ostbpo1me/security/screener?page=1&pageSize=1&sortOrder=name=asc&outputType=json&version=1&languageId=en-AU&currencyId=AUD&universeIds=UNIVE$$ALL&securityDataPoints=holdingTypeId%7CSecId%7CAPIR%7CName%7CExchangeCode%7CSymbol%7CFundShareClassId&filters=ExchangeID:EQ:" + this.mapAgilityExchangeCodeToMIC(exchangeCode) + "|Symbol:EQ:" + symbol,
                    type: "GET",
                }).then(res => {
                    if (res.total > 0) {
                        resolve(res.rows[0])
                    }else{
                        resolve(null)
                    }
                }).fail(res => {
                    resolve(res)
                })
            });
        }
        public getMorningStarDataForSecurityId(securityId): Promise<Patersons.MorningStarData>{
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "https://lt.morningstar.com/api/rest.svc/4ostbpo1me/security/screener?page=1&pageSize=1&sortOrder=name=asc&outputType=json&version=1&languageId=en-AU&currencyId=AUD&universeIds=UNIVE$$ALL&securityDataPoints=holdingTypeId%7CSecId%7CAPIR%7CName%7CExchangeCode%7CSymbol%7CFundShareClassId&filters=SecId:EQ:" + securityId,
                    type: "GET",
                }).then(res => {
                    if (res.total > 0) {
                        resolve(res.rows[0])
                    }else{
                        resolve(null)
                    }
                }).fail(res => {
                    resolve(res)
                })
            });
        }
    }
}